package com.ustadmobile.core.impl

class NoAppFoundException(message: String, var mimeType: String?) : Exception(message)
